/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../../colors';
import Label from '../Label';

const Container = styled.div`
  width: ${({ width }) => width};
`;

const StyledTextArea = styled.textarea`
  -webkit-appearance: none;
  border: 1px solid ${colors.smoke};
  border-radius: 3px;
  color: ${colors.ash};
  display: block;
  font-family: 'Quicksand', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  resize: vertical;
  width: 100%;

  ::placeholder {
    color: ${colors.smoke};
  }

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0.5);
  }

  &:active,
  &:focus {
    color: ${colors.charcoal};
    border-color: ${colors.primary};
    outline: 0;
  }

  &:disabled {
    background-color: ${colors.pearl};
    border-color: ${colors.cloud};
    box-shadow: none;
    cursor: default;
  }
`;

const TextAreaInput = ({
  label,
  onChange,
  rows,
  width,
  ...inputProps
}) => (
  <Container width={width}>
    {label && <Label htmlFor={inputProps.id}>{label}</Label>}
    <StyledTextArea
      {...inputProps}
      rows={rows}
      onChange={(changeEvent) => onChange(changeEvent.target.value)}
    />
  </Container>
);

TextAreaInput.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  width: PropTypes.string,
};

TextAreaInput.defaultProps = {
  disabled: false,
  id: null,
  label: null,
  onChange: () => {},
  rows: 3,
  width: '100%',
};

export default TextAreaInput;
